import { useRouteError } from "react-router-dom";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import * as Sentry from "@sentry/react";

export const RouteErrorBoundary = () => {
  const error = useRouteError() as Error;

  if (error) {
    Sentry.captureException(error);
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <Card className="w-full max-w-lg mx-4">
        <CardHeader className="space-y-3">
          <div className="flex items-center gap-2">
            <div className="flex size-10 items-center justify-center rounded-full bg-destructive/10">
              <AlertTriangle className="size-5 text-destructive" />
            </div>
            <CardTitle className="text-lg font-semibold">Page Error</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Something went wrong while loading this page.
          </p>

          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.reload()}
            className="gap-2"
          >
            <RefreshCw className="size-3.5" />
            Reload Page
          </Button>

          <div className="border-t pt-3">
            <p className="text-xs font-mono text-destructive break-words">
              {error?.message || "Unknown error"}
            </p>
            {(error as any)?.stack && (
              <pre className="mt-2 text-xs text-muted-foreground whitespace-pre-wrap break-words overflow-auto max-h-40">
                {(error as any).stack}
              </pre>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
